
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm5.361 13.63a7.25 7.25 0 10-10.722 0 6.904 6.904 0 0110.722 0zm-9.601 1a7.25 7.25 0 008.48 0 5.402 5.402 0 00-8.48 0zM7.294 5.449a3.827 3.827 0 115.412 5.412 3.827 3.827 0 01-5.412-5.412zM10 5.827a2.327 2.327 0 100 4.654 2.327 2.327 0 000-4.654z"}})])
          )
        }
      }
    